var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"af-icons-md af-icons-md-circle-processing af-icons-animate-rotate"}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"transcoding-status"},[_vm._v("\n      "+_vm._s(_vm.lang.get('files.transcoding.labels.in_progress'))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }